import React from 'react';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

const NewFeatures2 = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box>
            <Box marginBottom={4} sx={{display: 'flex', alignItems: 'center'}}>
                <Box
                    component={Typography}
                    fontWeight={700}
                    variant={'h4'}
                >
                    {t("home_page.new_features2.title")}
                </Box>
            </Box>
            <Box>
                <Grid container spacing={4}>
                    {[
                        {
                            title: t("home_page.new_features2.cards.card1.title"),
                            body: t("home_page.new_features2.cards.card1.body"),
                            icon: "/feature2/1.jpg"
                        },
                        {
                            title: t("home_page.new_features2.cards.card2.title"),
                            body: t("home_page.new_features2.cards.card2.body"),
                            icon: "/feature2/2.jpg"
                        },
                        {
                            title: t("home_page.new_features2.cards.card3.title"),
                            body: t("home_page.new_features2.cards.card3.body"),
                            icon: "/feature2/3.jpg"
                        },
                        {
                            title: t("home_page.new_features2.cards.card4.title"),
                            body: t("home_page.new_features2.cards.card4.body"),
                            icon: "/feature2/4.jpg"
                        },
                        {
                            title: t("home_page.new_features2.cards.card5.title"),
                            body: t("home_page.new_features2.cards.card5.body"),
                            icon: "/feature2/5.jpg"
                        },
                        {
                            title: t("home_page.new_features2.cards.card6.title"),
                            body: t("home_page.new_features2.cards.card6.body"),
                            icon: "/feature2/6.jpg"
                        },
                    ].map((item, i) => (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                            <Box
                                component={Card}
                                padding={4}
                                borderRadius={4}
                                width={'100%'}
                                height={'100%'}
                                data-aos={'fade-up'}
                                sx={{
                                    border: '1px solid #e0e0e0',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                }}
                            >
                                <Box display={'flex'} flexDirection={'column'}>

                                    <img src={item.icon} alt="new_features" style={{height: 45, width: 45}}/>
                                    <Box
                                        component={Typography}
                                        variant={'h6'}
                                        gutterBottom
                                        sx={{fontWeight: 700}}
                                    >
                                        {item.title}
                                    </Box>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{
                                            whiteSpace: 'pre-line',
                                            fontSize: 'small',
                                            color: 'gray'
                                        }}
                                    >
                                        {item.body}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default NewFeatures2;
